<template>
  <div class="ss">
    <p>1.用户每次下单即可参与免单抽奖，获奖的用户在订单完成24h后退回订单金额</p>
    <p>2.免单订单发起退款并且退款成功，则该笔订单的免单资格取消</p>
    <p>3.退回免单的金额可在【我的-我的钱包】提现</p>
    <p>*最终解释权归悦买所有</p>
  </div>
</template>

<script>
// import { getgoods, } from "@/api/join";
// import rules from "@/utils/rule";
export default {
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.ss {
  //  padding:20px;
  text-align: left;
  font-size: 14px;
}
p {
  text-indent: 32px;
  padding-right: 10px;
  padding-left: 10px;
}
</style>
